import type { RuntimeCampaign } from './types';

export interface FreeGiftItem {
  productId: string;
  variantId: string;
  quantity: number;
}

const PRODUCT_KEYS = ['product_id', 'productId', 'gift_product_id', 'giftProductId'];
const VARIANT_KEYS = ['variant_id', 'variantId', 'gift_variant_id', 'giftVariantId'];

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  return value as Record<string, unknown>;
}

function readString(source: Record<string, unknown>, keys: string[]): string {
  for (const key of keys) {
    const value = source[key];
    if (typeof value === 'string' && value.trim() !== '') return value.trim();
  }
  return '';
}

function readQuantity(source: Record<string, unknown>): number {
  const raw = source.quantity;
  const quantity = typeof raw === 'number' ? raw : typeof raw === 'string' ? Number(raw) : 1;
  return Number.isFinite(quantity) && quantity > 0 ? Math.floor(quantity) : 1;
}

function readFromRecord(source: Record<string, unknown>): FreeGiftItem | null {
  const productId = readString(source, PRODUCT_KEYS);
  if (!productId) return null;
  const variantId = readString(source, VARIANT_KEYS);
  if (!variantId) return null;
  return {
    productId,
    variantId,
    quantity: readQuantity(source),
  };
}

export function extractFreeGiftItem(campaign: RuntimeCampaign): FreeGiftItem | null {
  if (campaign.campaignType !== 'freegift_popup') return null;

  const settings = asRecord(campaign.settings);
  const fromSettings = settings ? readFromRecord(settings) : null;
  if (fromSettings) return fromSettings;

  const actions = Array.isArray(campaign.actions) ? campaign.actions : [];
  for (const action of actions) {
    const actionRecord = asRecord(action);
    const configRecord = asRecord(actionRecord?.config);
    const fromAction = configRecord ? readFromRecord(configRecord) : null;
    if (fromAction) return fromAction;
  }

  return null;
}
